import React, { useCallback, useRef } from 'react';
import { Params, useLocation } from 'react-router-dom';
import ScrollToContext, { StepsContextProps } from './ScrollTo.context';
import useEffectSkipFirst from '../../hooks/useEffectSkipFirst';
import useQueryParams from 'hooks/useQueryParams';

type ScrollToProps = {
  children: React.ReactNode;
};

export type StepsRef = StepsContextProps;

const ScrollTo: React.FC<ScrollToProps> = (props) => {
  const { children } = props;

  const container = useRef<HTMLElement>();
  const shouldScroll = useRef<boolean>(true);

  const { pathname, hash } = useLocation();

  const { params } = useQueryParams<Params>();

  useEffectSkipFirst(() => {
    if (hash || !shouldScroll.current) return;

    if (container.current) {
      container.current.scrollIntoView({ block: 'start' });
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
      });
    }
  }, [pathname, params]);

  const setContainer = useCallback((element: HTMLElement) => {
    container.current = element;
  }, []);

  const resetContainer = useCallback(() => (container.current = null), []);

  const setShouldScroll = useCallback(
    (value: boolean) => (shouldScroll.current = value),
    [],
  );

  return (
    <ScrollToContext.Provider
      value={{
        container,
        setContainer,
        setShouldScroll,
        resetContainer,
      }}
    >
      {children}
    </ScrollToContext.Provider>
  );
};

export default ScrollTo;
